// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/_index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/_index.tsx");
  import.meta.hot.lastModified = "1701885030601.2324";
}
// REMIX HMR END

import { json, redirect } from "@remix-run/node";
import Footer from "~/components/footer";
import nabLogo from "~/images/nab-logo.svg";
import { USER_SESSION_KEY, sessionStorage } from "~/session.server";
import { v4 as uuidv4 } from "uuid";
import Disabled from "~/components/disabled";
export const meta = () => [{
  title: "NAB Chat"
}];
export const loader = async ({
  request
}) => {
  const cookie = request.headers.get("Cookie");
  var session = await sessionStorage.getSession(cookie);
  if (!session.get(USER_SESSION_KEY)) {
    session.set(USER_SESSION_KEY, uuidv4());
    return redirect("/", {
      headers: {
        "Set-Cookie": await sessionStorage.commitSession(session)
      }
    });
  }
  return json({
    user: {
      id: session.get(USER_SESSION_KEY)
    }
  });
};
function Navigation() {
  return <nav className="fixed w-full bg-white z-10 top-0 flex items-center justify-between px-7 py-4 border-b border-gray-100">
        <div>
            <img src={nabLogo} alt="Logo" className="h-9" />
        </div>
    </nav>;
}
_c = Navigation;
export default function Index() {
  return <div className="bg-white font-sans">
      <Navigation />
      <Disabled />
      <Footer />
    </div>;
}
_c2 = Index;
var _c, _c2;
$RefreshReg$(_c, "Navigation");
$RefreshReg$(_c2, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;